var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.content
  }, [_vm.$slots.hasOwnProperty('overlay') ? _c('div', {
    class: _vm.$style.overlay
  }, [_vm._t("overlay")], 2) : _vm._e(), _c('div', {
    class: _vm.$style.poster
  }, [_vm._t("poster")], 2), _c('div', {
    class: _vm.$style.form
  }, [_c('div', {
    class: _vm.$style.logoMobile
  }, [_c('logo-medium')], 1), _vm._t("default"), _vm.$slots.hasOwnProperty('information') ? _c('div', {
    class: _vm.$style.informationMobile
  }, [_vm._t("information")], 2) : _vm._e()], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }